import { render, staticRenderFns } from "./TeamButtons.vue?vue&type=template&id=77b9d66d"
import script from "./TeamButtons.vue?vue&type=script&lang=js"
export * from "./TeamButtons.vue?vue&type=script&lang=js"
import style0 from "./TeamButtons.vue?vue&type=style&index=0&id=77b9d66d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports